module.exports = require('./payment-terms-popover-form-abstract-days').extend({
    layoutName: 'components/payment-terms-popover-form-net-end-of-month'
})
